/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_AgriculturalInputs */

const en_val_agricultural = /** @type {(inputs: Val_AgriculturalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agricultural`)
};

const es_val_agricultural = /** @type {(inputs: Val_AgriculturalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agrícola`)
};

const fr_val_agricultural = /** @type {(inputs: Val_AgriculturalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agricole`)
};

const de_val_agricultural = /** @type {(inputs: Val_AgriculturalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Landwirtschaftlich`)
};

const ja_val_agricultural = /** @type {(inputs: Val_AgriculturalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`農業用`)
};

const zh_val_agricultural = /** @type {(inputs: Val_AgriculturalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`农业`)
};

const ar_val_agricultural = /** @type {(inputs: Val_AgriculturalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`زراعي`)
};

const id_val_agricultural = /** @type {(inputs: Val_AgriculturalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pertanian`)
};

const it_val_agricultural = /** @type {(inputs: Val_AgriculturalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agricolo`)
};

const ru_val_agricultural = /** @type {(inputs: Val_AgriculturalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Земля с/х назначения`)
};

const pt_val_agricultural = /** @type {(inputs: Val_AgriculturalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agrícola`)
};

const ko_val_agricultural = /** @type {(inputs: Val_AgriculturalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`농업용`)
};

/**
* | output |
* | --- |
* | "Agricultural" |
*
* @param {Val_AgriculturalInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_agricultural = /** @type {((inputs?: Val_AgriculturalInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_AgriculturalInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_agricultural(inputs)
	if (locale === "es") return es_val_agricultural(inputs)
	if (locale === "fr") return fr_val_agricultural(inputs)
	if (locale === "de") return de_val_agricultural(inputs)
	if (locale === "ja") return ja_val_agricultural(inputs)
	if (locale === "zh") return zh_val_agricultural(inputs)
	if (locale === "ar") return ar_val_agricultural(inputs)
	if (locale === "id") return id_val_agricultural(inputs)
	if (locale === "it") return it_val_agricultural(inputs)
	if (locale === "ru") return ru_val_agricultural(inputs)
	if (locale === "pt") return pt_val_agricultural(inputs)
	return ko_val_agricultural(inputs)
});